<template>
  <div>
    <div>
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-radio
          v-model="tableType"
          class="custom-radio"
          custom-error-msg="El campo es requerido."
          :disabled="isReadOnly"
          :error="!!errors[0]"
          name="tableType"
          :options="tableOptions"
        />
      </validation-provider>
    </div>
    <div v-if="!isReadOnly" class="my-3">
      <div class="col d-flex align-items-end">
        <custom-drop-down
          v-model="moduleSelected"
          class="w-40"
          :clearable="false"
          fieldkey="id"
          fieldname="name"
          is-html
          label="Prueba/Muestra - Módulo:"
          :options="modules"
          placeholder="Seleccione"
        />
        <action-button
          class="ml-2"
          :disabled="!moduleSelected"
          i="fas fa-file-plus"
          variant="success"
          @click="addModule()"
        >
          Añadir
        </action-button>
      </div>
      <validation-provider
        ref="modules"
        v-slot="{ errors }"
        name="modules"
        :rules="model.areas.length > 0 ? '' : 'required'"
      >
        <error
          v-if="errors[0]"
          class="m-3"
          message="Añada al menos un módulo"
          variant="no-border"
        />
      </validation-provider>
    </div>
    <div class="m-3">
      <div v-for="item in model.areas" :key="item.area.id">
        <answer
          :is-read-only="isReadOnly"
          :value="item"
          @input="onAnswer(item, $event)"
          @remove="removeArea($event)"
        />
      </div>
    </div>
    <div class="m-3">
      <label class="font-weight-bold">
        Interpretación de las pruebas SAM administradas de acuerdo con los
        resultados obtenidos:
      </label>
      <p v-if="isReadOnly">{{ model.comment | empty }}</p>
      <validation-provider v-else v-slot="{ errors }" rules="required">
        <custom-text-area
          v-model="model.comment"
          :count-classes="['d-block', 'small-counter', 'text-right']"
          custom-error-msg="El campo es requerido."
          :error="errors[0]"
          :maxlength="5000"
          show-char-count
        />
      </validation-provider>
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';

import Answer from './components/AreaAnswer.vue';

import CustomRadio from 'custom-radio';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import Error from 'custom-error';

export default {
  name: 'WorkSampleExecution',
  components: {
    Answer,
    CustomRadio,
    CustomDropDown,
    ActionButton,
    CustomTextArea,
    Error,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moduleSelected: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    tableType: {
      get() {
        return this.tableOptions.find((x) => x.value === this.model.tableType);
      },
      set(option) {
        this.model.tableType = option?.value;
      },
    },
    tableOptions() {
      return [
        {
          name: '1',
          label:
            'Tabla Normalizada: Promedio de estudiantes de escuela superior',
          value: 1,
        },
        {
          name: '2',
          label:
            'Tabla de conversión y Estándar de error de medidas MTM (para volver a administrar una prueba)',
          value: 2,
        },
      ];
    },
    areaIds() {
      return this.model.areas?.map((a) => a.area?.id) ?? [];
    },
    modules() {
      return (this.model.modules ?? [])
        .filter((m) => !this.areaIds.includes(m.id))
        .map((x) => ({
          id: x.id,
          name: x.letter?.trim() ? `<b>${x.name}</b> (${x.letter})` : x.name,
        }));
    },
  },
  methods: {
    onAnswer(item, value) {
      const index = this.model.areas.findIndex(
        (a) => a.area?.id === item.area.id
      );
      if (index !== -1) this.model.areas[index] = value;
    },
    addModule() {
      if (!this.moduleSelected) return;
      const area = this.model.modules.find(
        (m) => m.id === this.moduleSelected.id
      );
      if (!area) return;
      this.model.areas.push({
        area,
        comment: null,
      });
      this.$refs.modules.setErrors({ modules: null });
      this.moduleSelected = null;
    },
    removeArea(area) {
      this.model.areas = this.model.areas.filter(
        (a) => a.area.id !== area.area.id
      );
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-radio {
  margin-bottom: 20px;
}
::v-deep .custom-radio .custom-control-label {
  font-weight: 700;
}
</style>
